import React from 'react';
import cn from "classnames";
import { replaceSpacesWithHyphens } from '../../utils/formatPricingNumber';

//const Video = () => {
const AssetCard = props => {
    //console.debug('AssetCard()', props);

    /*
    let videoSrc;
    if (props.filePath) {
        videoSrc = props.filePath
    } else {
        videoSrc = "/videos/" + props.fileName;
    }
    */
    let index = props.index;
    let assetObject = props.assetObject;
    let categoryName = props.categoryName;
    let clickSearchResult = props.clickSearchResult;

    return (
        <div
            key = { index }
            //className={styles.assetContainer}
            //className = 'asset-container'
            className = {
                cn(
                    'asset-container'
                    , assetObject?.availableFractions > 0 ? 'asset-available' : ''
                    //, 'Available'
                    //, assetObject?.saleType
                    , replaceSpacesWithHyphens(assetObject?.status)
                )
            }
            
            //onClick = { () => navigate('/item/' + assetObject?.id) }
            //onClick = { () => clickSearchResult(assetObject?.id) }
            onClick = { () => clickSearchResult(assetObject) }
            style = {{
                paddingBottom: '10px'
                //, cursor: 'pointer'
                //, flexGrow: '1'
                //, flexShrink: '1'
                //, flexBasis: '300px'
            }}>

            {/*
            <img
                src = {
                       assetObject?.asset?.thumbnailUrl
                    || assetObject?.asset?.mediaPreviewUrl
                }
                //className = { styles.thumbnailImage }
                className = 'thumbnail'
                alt = 'thumbnail.png'
                />
            */}

            {/* Previous button without the Past Deals flag.
            <div
                //className = { cn("item", categoryName, styles.item)}
                className = { cn("item", categoryName) }
                //onClick={() => navigate("/item/" + assetObject?.id)}
                //onClick = { () => navigate("/search/" + categoryName); return false; }
                //onClick = { (event) => clickCategory(getCategoryName(assetObject?.asset.categoryId), event) }
                onClick = { (event) => clickCategoryId(assetObject?.asset.categoryId, event) }
                //onClick = { function() { navigate("/search/" + getCategoryName(assetObject?.asset.categoryId)); return false; }
                    style = {{ position: 'relative' }}
                >
                <div
                    className = { cn('item-top') }
                    style = {{
                        position: 'absolute'
                        , right: '0'
                        , margin: '10px'
                    }}
                    >
                    <button
                        style = {{
                            textAlign: 'right'
                            , margin: 'auto'
                        }}
                        className = 'text-shadow'
                        >
                        { categoryName }
                    </button>
                </div>
            </div>
            */}

            <div
                className = { cn("item", categoryName) }
                style = {{
                    position: 'relative'
                }}>

                <div
                    //className = { categoryName }
                    //className = { cn(categoryName, 'text-shadow') }
                    className = { cn('item-top') }
                    style = {{
                        position: 'absolute'
                        //, top: '-28px'
                        , bottom: '-48px'
                        , right: '0'
                        , margin: '10px'
                        , whiteSpace: 'nowrap'
                    }}>

                    {
                        //productDetails?.status == 'past-deal'
                        //assetObject?.asset?.status == 'past-deal'
                        //assetObject?.saleType == 'past-deal'
                        assetObject?.status
                        ? <div
                            //className = { cn(assetObject?.status) }
                            style = {{
                                //color: 'white'
                                display: 'flex'
                                //, marginLeft: '8px'
                                , margin: 'auto'
                                //, position: 'absolute'
                                //, right: '0'
                                //, top: '-40px'
                                //, border: 'red 1px solid'
                                , textAlign: 'center'
                            }}>
                            <div
                                className = {
                                    cn(
                                        'flag-tag'
                                        //, assetObject?.status
                                        , replaceSpacesWithHyphens(assetObject?.status)
                                    )
                                }
                                /*
                                style = {{
                                      padding: '3px 8px'
                                    //, fontSize: '13px'
                                    , fontWeight: '500'
                                    , verticalAlign: 'top'
                                    , fontFamily: 'DM Sans'
                                    , textAlign: 'center'
                                    , textTransform: 'none'
                                    //, border: 'red 2px solid'
                                    //, borderWidth: '2px 2px 0px 2px'
                                    //, backgroundColor: 'white'
                                    //, backgroundColor: 'red'
                                    , borderTopLeftRadius: '3px'
                                    , borderTopRightRadius: '3px'
                                    , margin: 'auto'
                                    //, color: 'red'
                                    //, color: 'white'
                                    , boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.5)'
                                }}
                                */
                                >
                                { assetObject?.status }
                            </div>
                        </div>

                        : <div
                            //className = { cn('Available', assetObject?.saleType, assetObject?.status) }
                            style = {{
                                //color: 'white'
                                display: 'flex'
                                //, marginLeft: '8px'
                                , margin: 'auto'
                                //, position: 'absolute'
                                //, right: '0'
                                //, top: '-40px'
                                //, border: 'red 1px solid'
                                , textAlign: 'center'
                            }}>

                            <div
                                className = {
                                    cn(
                                        'flag-tag'
                                        , 'Available'
                                        , assetObject?.saleType
                                        //, assetObject?.status
                                        , replaceSpacesWithHyphens(assetObject?.status)
                                    )
                                }
                                /*
                                style = {{
                                      padding: '3px 8px'
                                    //, fontSize: '13px'
                                    , fontWeight: '500'
                                    , verticalAlign: 'top'
                                    , fontFamily: 'DM Sans'
                                    , textAlign: 'center'
                                    , textTransform: 'none'
                                    //, border: 'green 2px solid'
                                    //, borderWidth: '2px 2px 0px 2px'
                                    , borderWidth: '2px'
                                    , borderBottomWidth: '0px'
                                    //, backgroundColor: 'white'
                                    //, backgroundColor: assetObject?.isResell ? 'green' : 'white'
                                    //, backgroundColor: 'green'
                                    , borderTopLeftRadius: '3px'
                                    , borderTopRightRadius: '3px'
                                    , margin: 'auto'
                                    //, color: 'green'
                                    //, color: assetObject?.isResell ? 'white' : 'green'
                                    //, color: 'white'
                                    , boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.5)'
                                }}
                                */
                                >
                                {
                                    assetObject?.isResell
                                    ? <span>Resale {
                                            assetObject?.availableFractions
                                        }/{
                                            assetObject?.totalFractions
                                        }
                                    </span>
                                    : <span>Available</span>
                                }
                            </div>
                        </div>
                    }

                    <button
                        className = { cn('flag', categoryName, 'text-shadow') }
                        //style = {{
                        //    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.5)'
                        //    , fontSize: '14px'
                        //}}
                        >
                        { categoryName }
                    </button>

                </div>

            </div>

            <div
                className = 'preview-image'
                style = {{
                      backgroundImage: 'url(' + (assetObject?.asset?.thumbnailUrl || assetObject?.asset?.mediaPreviewUrl) + ')'
                    , backgroundSize: 'cover'

                    /*
                    , backgroundRepeat: 'no-repeat'
                    , backgroundPosition: 'center'
                    //, backgroundSize: 'cover'
                    //, backgroundSize: 'auto 100%'
                    //, backgroundSize: '100% auto'
                    , backgroundSize: '100% 100%'
                    , borderTopLeftRadius: '10px'
                    , borderTopRightRadius: '10px'
                    , width: '335px'
                    //, minWidth: '64px'
                    , height: '180px'
                    */
                }}
                >
            </div>

            <div
                className = 'preview-text'
                //style = {{
                //      padding: '10px 10px 5px 10px'
                //    , margin: '0px'
                //    , display: 'flex'
                //    , flexWrap: 'wrap'
                //    , justifyContent: 'space-between'
                //}}
                >

                <div className = 'watch-info-box'>
                    <div>
                        <div
                            className = 'watch-title'
                            style = {{
                                //maxWidth: '220px'
                                maxWidth: '315px'
                            }}
                            >
                            { assetObject?.asset?.name }
                        </div>
                    </div>
                    <div>
                        <div
                            className = 'watch-subtitle'
                            style = {{ maxWidth: '220px' }}>
                            { assetObject?.asset?.location }
                        </div>
                    </div>
                </div>

                {/*
                <div
                    //className = { cn("item", categoryName, styles.item)}
                    className = { cn("item", categoryName) }
                    //onClick={() => navigate("/item/" + assetObject?.id)}
                    //onClick = { () => navigate("/search/" + categoryName); return false; }
                    //onClick = { (event) => clickCategory(getCategoryName(assetObject?.asset.categoryId), event) }
                    onClick = { (event) => clickCategoryId(assetObject?.asset.categoryId, event) }
                    //onClick = { function() { navigate("/search/" + getCategoryName(assetObject?.asset.categoryId)); return false; }
                    >
                    <div className = { cn('item-top') }>
                        <button>
                            { categoryName }
                        </button>
                    </div>
                </div>
                */}

                {/*
                <div className={'price-box'}
                    style = {{
                          display: "flex"
                        , flexWrap: "wrap"
                        , justifyContent: "space-between"
                        , maxWidth: "220px"
                    }}
                    >

                    <div>
                        <div className = { 'table' }>
                            <div className = { 'row' }>
                                <div style = {{ whiteSpace: 'nowrap' }}>Price USD</div>
                            </div>
                            <div className = { 'row' }>
                                <div className={`price price-dollars ${styles.price}}`}>
                                    US${displayPrice(assetObject?.asset, exchangeRate)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className = { 'table' }>
                            <div className = { 'row' }>
                                <div style = {{ whiteSpace: 'nowrap' }}>Price Crypto</div>
                            </div>
                            <div className = { 'row' }>
                                <div
                                    className={cn('price', 'price-crypto')}
                                    style = {{ whiteSpace: 'nowrap' }}
                                    >
                                    {(
                                      assetObject?.asset?.regularPrice
                                    ).toFixed(CRYPTOCURRENCY_CONSTANTS.CRYPTO_PRICE_DECIMAL_PLACES)}{' '}
                                    MATIC
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                */}
            </div>

            {
                //assetObject?.asset?.status != 'past-deal'
                //assetObject?.asset?.status != 'available'
                assetObject?.status == 'Available'
                ?
                    <div
                        className = 'small-details'
                        //style = {{
                        //    paddingBottom: '10px'
                        //}}
                        >

                        <span className = 'label'>Closing Date:</span>
                        &nbsp;
                        <span>{
                            new Date(
                                Date.parse(assetObject?.asset.closingDate)
                            )
                            .toLocaleDateString(
                                "en-US"
                                //, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }
                                //, { year: 'numeric', month: 'long', day: 'numeric' }
                                , { year: 'numeric', month: 'short', day: 'numeric' }
                            )
                        }</span>
                    </div>
                :
                    assetObject?.asset?.status == 'past-deal'
                    && <div
                        className = 'small-details'
                        //style = {{
                        //    display: 'inline-block'
                        //    , textAlign: 'right'
                        //    , lineHeight: '18px'
                        //}}
                        >
                        <span className = 'label'>Price:</span>
                        &nbsp;
                        <span style = {{ whiteSpace: 'nowrap' }}>
                            {
                                assetObject?.asset?.purchasePrice
                            }
                        </span>

                        {/*
                        */}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span className = 'label'>ROI:</span>
                        &nbsp;<span style = {{ whiteSpace: 'nowrap' }}>
                            {
                                assetObject?.asset?.returnOnInvestment
                            }
                        </span>
                    </div>
            }

        </div>
    );
}

export default AssetCard;
